import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
const defaultOptions = {} as const;

export type LinkAccountsMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateAccountConnectionsInput;
}>;

export type LinkAccountsMutationResult = { __typename?: 'Mutation' } & {
  createAccountConnections?: GraphQLTypes.Maybe<
    { __typename?: 'CreateAccountConnectionsPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const LinkAccountsDocument = /*#__PURE__*/ gql`
  mutation linkAccounts($input: CreateAccountConnectionsInput!) {
    createAccountConnections(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useLinkAccountsMutation__
 *
 * To run a mutation, you first call `useLinkAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAccountsMutation, { data, loading, error }] = useLinkAccountsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkAccountsMutation(
  baseOptions?: Apollo.MutationHookOptions<LinkAccountsMutationResult, LinkAccountsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<LinkAccountsMutationResult, LinkAccountsMutationVariables>(LinkAccountsDocument, options);
}
export type LinkAccountsMutationHookResult = ReturnType<typeof useLinkAccountsMutation>;
